export default "__VITE_ASSET__25b4c320__"